import { Component } from '@angular/core';
import { ClrIconModule } from "@clr/angular";
import { ClarityIcons, moonIcon, sunIcon} from "@cds/core/icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [
    ClrIconModule,
    NgIf
  ],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.sass'
})
export class ThemeToggleComponent {
  theme: 'dark' | 'light' = 'dark';

  ngOnInit() {
    const savedTheme = localStorage.getItem('theme') as 'dark' | 'light';
    if (savedTheme) {
      this.theme = savedTheme;
      document.body.setAttribute('cds-theme', this.theme);
    }
  }

  constructor() {
    ClarityIcons.addIcons(moonIcon, sunIcon);
  }

  toggleTheme() {
    this.theme = this.theme === 'dark' ? 'light' : 'dark';
    document.body.setAttribute('cds-theme', this.theme);
    localStorage.setItem('theme', this.theme);
  }

  get iconShape(): string {
    return this.theme === 'dark' ? 'sun' : 'moon';
  }

  get themeText(): string {
    return this.theme === 'dark' ? 'Light' : 'Dark';
  }
}
